import { t } from 'i18next'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Box, Button } from '@mui/material'

import { useViewTransitionNavigate } from '../../../hooks/useViewTransitionNavigate'

type BackButtonProps = {
  url?: string
  mb?: number
  text?: string
  viewTransition?: boolean
}
export const BackButton: FC<BackButtonProps> = ({ url, mb = 2, text, viewTransition = false }) => {
  const navigate = useNavigate()
  const navigateWithTransition = useViewTransitionNavigate()
  return (
    <Box mb={mb}>
      <Button
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        onClick={() => {
          if (url) {
            viewTransition ? navigateWithTransition(url) : navigate(url)
          } else {
            navigate(-1)
          }
        }}
      >
        {text ?? t('internal-common:back')}
      </Button>
    </Box>
  )
}
